<template>
	<!-- <transition :name="transitionName"> -->
    <div>
      <div class="back-to-ceiling" @click="toFaq" :style="customStyle">
        <!-- <i class="el-icon-arrow-up"></i> -->
       <!-- <?xml version="1.0" encoding="UTF-8"?> -->
        <!-- <?xml version="1.0" encoding="UTF-8"?> -->
          <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 58 (84663) - https://sketch.com -->
            <title>ic_group_profile_contribution_help@2x</title>
            <desc>Created with Sketch.</desc>
            <g id="PC" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="首页增加活动模块备份-4" transform="translate(-1885.000000, -1812.000000)">
                    <g id="编组-3备份" transform="translate(1870.000000, 1806.000000)">
                        <g id="ic_贡献榜_help" transform="translate(15.000000, 6.000000)">
                            <g id="ic_group_profile_contribution_help" transform="translate(2.000000, 0.000000)">
                                <circle id="Oval" fill="#8FC2FD" cx="8" cy="10" r="8"></circle>
                                <path d="M8.147,4.808 C7.125,4.808 6.313,5.102 5.725,5.704 C5.123,6.292 4.829,7.09 4.829,8.112 L6.313,8.112 C6.313,7.496 6.439,7.006 6.691,6.67 C6.971,6.278 7.433,6.082 8.063,6.082 C8.567,6.082 8.959,6.222 9.239,6.502 C9.505,6.782 9.645,7.16 9.645,7.65 C9.645,8.014 9.519,8.35 9.267,8.672 L9.029,8.938 L8.6522426,9.27951843 C8.00526036,9.88030769 7.59884615,10.3423077 7.433,10.674 C7.251,11.038 7.167,11.486 7.167,12.004 L7.167,12.242 L8.665,12.242 L8.665,12.004 C8.665,11.654 8.735,11.346 8.889,11.066 C9.015,10.814 9.211,10.576 9.463,10.352 L10.0421852,9.848 C10.3667778,9.55866667 10.569,9.36266667 10.653,9.26 C10.989,8.812 11.171,8.238 11.171,7.552 C11.171,6.712 10.891,6.04 10.345,5.55 C9.785,5.046 9.057,4.808 8.147,4.808 Z M7.909,12.998 C8.203,12.998 8.455,13.082 8.651,13.278 C8.847,13.46 8.945,13.698 8.945,13.992 C8.945,14.286 8.847,14.524 8.651,14.72 C8.441,14.902 8.189,15 7.909,15 C7.615,15 7.377,14.902 7.195,14.706 C6.985,14.51 6.887,14.272 6.887,13.992 C6.887,13.74 6.959,13.5291429 7.11181633,13.3594286 L7.195,13.278 C7.377,13.082 7.615,12.998 7.909,12.998 Z" id="?" fill="#FFFFFF" fill-rule="nonzero"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        <p>问题</p>
      </div>
    </div>
	<!-- </transition> -->
</template>

<script>
import { mapGetters } from 'vuex'
import UploadPicture from '@/components/UploadPicture'
export default {
  name: 'faq',
  components: {
    UploadPicture
  },
	data() {
		return {
      customStyle: {
        right: '15px',
        bottom: '78px',
        width: '50px',
        height: '50px',
        background: '#fff',
        border: '1px solid #F0F2F5',
        zIndex: 1000
      },
    }
  },
  computed: {
      ...mapGetters([
        'uid',
        'name'
      ])
  },
	created() {
	},
	methods: {
    toFaq() {
      this.$util.doSensorsTrack('CommonProblemClk', {
          TriggerPage: this.$route.name === 'homepage' ? 'CreatorCenterHome' : 'Otherpage',
          CurrentOperatorId: this.uid || '',
          CurrentOperatorIdName: this.name || '',
      })
      this.$router.push('/faq')
    },
	}
}
</script>

<style lang="scss" scoped>
.el-form .el-input, .el-form .el-textarea {
  max-width: 100%;
}
svg {
  margin: 0 auto;
}
.back-to-ceiling {
	position: fixed;
	z-index: 1;
	display: inline-block;
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #666;
	text-align: center;
	cursor: pointer;
	p {
		line-height: 1.2;
		font-size: 12px;
	}
	&:hover {
		opacity: 0.85;
	}
	.icon--backToTopArrow {
		fill: #bfc1c8;
		background: none;
		margin: 0 auto 4px;
	}
}
</style>
